namespace TabAurous.Production {
    export interface ReceiptMaterialDetailsForm {
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        ItemDetails: ReceiptMaterialItemsEditor;
    }

    export class ReceiptMaterialDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.ReceiptMaterialDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptMaterialDetailsForm.init)  {
                ReceiptMaterialDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = ReceiptMaterialItemsEditor;

                Q.initFormType(ReceiptMaterialDetailsForm, [
                    'DepartmentId', w0,
                    'BagNo', w1,
                    'ProductCode', w1,
                    'Line_No', w1,
                    'Pieces', w2,
                    'Weight', w3,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'Attribute', w1,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
